// placement: ,
import {Tooltip} from "@mui/material";
import {FC, ReactElement} from "react";
import {ITooltipProps} from "@ui/tooltipCustom/types";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps extends ITooltipProps {
    children: ReactElement | string,
    sxWrapper?: SxType
}

const TooltipCustom: FC<IProps> = ({
                                       enterDelay = 500,
                                       enterNextDelay = 500,
                                       arrow = true,
                                       title,
                                       children,
                                       placement,
                                       sxWrapper,
                                   }) => {

    return (
        <Tooltip
            enterDelay={enterDelay}
            enterNextDelay={enterNextDelay}
            title={title}
            arrow={arrow}
            placement={placement}
        >
           <span
               key={title}
               style={sxWrapper as any}
           >
               {children}
           </span>
        </Tooltip>
    );
}
export default TooltipCustom;
